module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-600.f53b3f8d.ttf";